module.exports = __webpack_public_path__ + "static/img/2.7c2a231.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/zh/2.png
// module id = LdR5
// module chunks = 0